module.exports = __webpack_public_path__ + "img/s_03.96c4de54.png";